<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ApJs1L/tc-custom/9780785226543.jpg?1726755940219" alt="This image is the cover for the book Bottom of the Pool"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bottom of the Pool
      </h1>
      <p class="bookDescription body article font2">
        <p><i>This is how it’s done. This is why it’s done this way. This is the result you can expect if you do it.</i></p><p>These three pieces of information inform a conclusion about every part of each of our lives. Yet it is these three pieces of information that most often set an insidious trap—a trap that has held the imaginations of generations captive to the belief that because they are doing the best they can do, they are accomplishing the best that can be done. And while each of these three statements are true, not one of them is the truth.</p><p>Dive deeper with bestselling author Andy Andrews as he shares his unique philosophy regarding foundational thinking. Through his unique and captivating storytelling, Andy helps you search for the reality that lies beyond the boundaries established in the name of “best practices,” “industry standards,” or “the way things are done.” For it’s at the bottom of the pool that you discover a pathway to extraordinary results that most people in your position do not even know are possible.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Andrews
      </h2>
      
      <p class="authorDescription body article"><P>Andy Andrews is a bestselling novelist, speaker, and consultant for some of the world&rsquo;s most successful teams, largest corporations, and fastest-growing organizations. He is the author of the <I>New York Times</I> bestsellers <I>The Noticer</I>, <I>How Do You Kill 11 Million People?</I>, and the modern classic <I>The Traveler&rsquo;s Gift</I>. For more information, please visit AndyAndrews.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?407337dc